import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import {
  Card,
  CardContent,
  Typography,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper
} from '@mui/material';

import {
  fetchIssuesActionTypes,
  fetchIssuesInfoTypes,
  fetchIssuesResolutionTypes
} from 'src/actions/issuesActions';

import IssueActionForm from './IssueActionForm';

const sizeMap = {
  xs: 40,
  sm: 80,
  md: 120,
  lg: 200,
};




const IssueDetails = ({ customerId, issueId, data, serverTypes }) => {
  const dispatch = useDispatch();
  const [resolutionTypes, setResolutionTypes] = useState([]);
  const [actionTypes, setActionTypes] = useState([]);
  const [infoTypes, setInfoTypes] = useState([]);

  console.log("IssueActionForm() ", issueId, data);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [resTypes, actTypes, infTypes] = await Promise.all([
          dispatch(fetchIssuesResolutionTypes()),
          dispatch(fetchIssuesActionTypes()),
          dispatch(fetchIssuesInfoTypes())
        ]);
        setResolutionTypes(resTypes || []);
        setActionTypes(actTypes || []);
        setInfoTypes(infTypes || []);
      } catch (error) {
        console.error("Error fetching issue types:", error);
      }
    };

    if (data) {
      fetchData();
    }
  }, [data]);

  if (!data) return null;

  const { description, refs, actors } = data;

  return (
    <Grid container spacing={2} margin={4}>
      {/* Basic Info */}
      <Grid container spacing={2} mb={3}>
        <Grid item xs={6}>
          <Typography><strong>Customer ID:</strong> {customerId}</Typography>
        </Grid>
        <Grid item xs={6}>
          {/* <Typography><strong>ONDC Order ID:</strong> {data.ondcOrderId || '-'}</Typography> */}
        </Grid>
        <Grid item xs={6}>
          <Typography><strong>Issue ID:</strong> {issueId}</Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography><strong>Status:</strong> {data.status}</Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography><strong>Response Time:</strong> {data.expected_response_time?.duration || '-'}</Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography><strong>Resolution Time:</strong> {data.expected_resolution_time?.duration || '-'}</Typography>
        </Grid>
      </Grid>

      {/* Images */}
      {description?.images?.length > 0 && (
        <Grid item xs={12}>
          <Typography variant="h6" gutterBottom>Attached Images</Typography>
          <Grid container spacing={2}>
            {description.images.map((imgUrl, idx) => (
              <Grid item key={idx}>
                <img src={imgUrl} alt={`issue-img-${idx}`} style={{ maxWidth: 200, borderRadius: 8 }} />
              </Grid>
            ))}
          </Grid>
        </Grid>
      )}

      {/* Additional Description Content (e.g., image/pdf/video URL) */}
      {description?.additional_desc?.url && (
        <Grid item xs={12}>
          <Typography variant="h6" gutterBottom>Additional Description</Typography>
          {description.additional_desc.content_type?.startsWith('image/') ? (
            <img
              src={description.additional_desc.url}
              alt="Additional Content"
              style={{ maxWidth: 300, borderRadius: 8 }}
            />
          ) : (
            <a href={description.additional_desc.url} target="_blank" rel="noopener noreferrer">
              View Content
            </a>
          )}
        </Grid>
      )}

      {/* References */}
      {refs?.length > 0 && (
        <Grid item xs={12}>
          <Typography variant="h6" gutterBottom>References</Typography>
          <TableContainer component={Paper}>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell><strong>Ref Type</strong></TableCell>
                  <TableCell><strong>Ref ID</strong></TableCell>
                  <TableCell><strong>Tags</strong></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {refs.map((ref, i) => (
                  <TableRow key={i}>
                    <TableCell>{ref.ref_type}</TableCell>
                    <TableCell>{ref.ref_id}</TableCell>
                    <TableCell>
                      {ref.tags?.length > 0 ? (
                        ref.tags.map((tag, idx) => (
                          <div key={idx}>
                            <strong>{tag.descriptor?.code}</strong>:
                            {tag.list?.map((item, i2) => (
                              <div key={i2}>
                                {item.descriptor?.code}: {item.value}
                              </div>
                            ))}
                          </div>
                        ))
                      ) : (
                        '-'
                      )}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      )}

      {/* Actors */}
      {actors?.length > 0 && (
        <Grid item xs={12}>
          <Typography variant="h6" gutterBottom>Actors</Typography>
          <TableContainer component={Paper}>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell><strong>ID</strong></TableCell>
                  <TableCell><strong>Type</strong></TableCell>
                  <TableCell><strong>Name</strong></TableCell>
                  <TableCell><strong>Email</strong></TableCell>
                  <TableCell><strong>Phone</strong></TableCell>
                  <TableCell><strong>Organization</strong></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {actors.map((actor, i) => (
                  <TableRow key={i}>
                    <TableCell>{actor.id}</TableCell>
                    <TableCell>{actor.type}</TableCell>
                    <TableCell>{actor.info?.person?.name || '-'}</TableCell>
                    <TableCell>{actor.info?.contact?.email || '-'}</TableCell>
                    <TableCell>{actor.info?.contact?.phone || '-'}</TableCell>
                    <TableCell>{actor.info?.org?.name || '-'}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      )}

      {/* Action Form */}
      <Grid item xs={12} mb={3}>
        <IssueActionForm
          customerId={customerId}
          issueId={issueId}
          resolutionTypes={resolutionTypes}
          actionTypes={actionTypes}
          infoTypes={infoTypes}
          serverTypes={serverTypes}
        />
      </Grid>

      {/* Actions */}
      {data.actions?.length > 0 && (
        <Grid item xs={12}>
          <Typography variant="h6" gutterBottom>Actions</Typography>
          <TableContainer component={Paper}>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell><strong>ID</strong></TableCell>
                  <TableCell><strong>Code</strong></TableCell>
                  <TableCell><strong>Description</strong></TableCell>
                  <TableCell><strong>Updated At</strong></TableCell>
                  <TableCell><strong>Action By</strong></TableCell>
                  <TableCell><strong>Actor Name</strong></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data.actions.map((action, index) => (
                  <TableRow key={action.id || index}>
                    <TableCell>{action.id}</TableCell>
                    <TableCell>{action.description?.code || action.descriptor?.code || '-'}</TableCell>
                    <TableCell>{action.description?.short_desc || action.descriptor?.short_desc || '-'}</TableCell>
                    <TableCell>
                      {action.updated_at
                        ? new Date(action.updated_at).toLocaleString()
                        : '-'}
                    </TableCell>
                    <TableCell>{action.action_by}</TableCell>
                    <TableCell>{action.actor_details?.name || '-'}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      )}


      <Typography variant="h6" gutterBottom mt={2}>Descriptor Images</Typography>

      {/* Descriptor Images and Media */}
      {(data?.descriptor?.images?.length > 0 || data?.descriptor?.media?.length > 0) && (
        <Grid item xs={12}>
          <Typography variant="h6" gutterBottom>Issue Media</Typography>
          <Grid container spacing={2}>
            {/* Display Images */}
            {data.descriptor.images?.map((imgUrl, idx) => (
              <Grid item key={`desc-img-${idx}`} xs={12}>
                <img
                  src={imgUrl?.url}
                  alt={`descriptor-img-${idx}`}
                  style={{
                    width: sizeMap[imgUrl?.size_type] || 100,
                    height: "auto",
                    borderRadius: 8,
                    objectFit: "contain",
                  }}
                />
              </Grid>
            ))}

            {/* Display Other Media */}
            {data.descriptor.media?.map((media, idx) => (
              <Grid item key={`desc-media-${idx}`} >
                <Typography> Media ({idx}) </Typography>
                {media.url?.endsWith('.mp4') ? (
                  <video controls width="250">
                    <source src={media.url} type={media.content_type || 'video/mp4'} />
                    Your browser does not support the video tag.
                  </video>
                ) : media.content_type?.includes('pdf') ? (
                  <a href={media.url} target="_blank" rel="noopener noreferrer">
                    View PDF Document
                  </a>
                ) : (
                  <a href={media.url} target="_blank" rel="noopener noreferrer">
                    View Media
                  </a>

                  //     <img
                  //   src={media?.url}
                  //   alt={`descriptor-img-${idx}`}
                  //   style={{
                  //     width: sizeMap[media?.size_type] || 100,
                  //     height: "auto",
                  //     borderRadius: 8,
                  //     objectFit: "contain",
                  //   }}
                  // />                  
                )}
              </Grid>
            ))}

          </Grid>

          <Grid item key="additional_desc" xs={12} mt={2}>
            <Typography> Additional Description </Typography>
            <img
              src={data.descriptor?.additional_desc?.url}
              alt="additional_desc-img"
              style={{
                width: "80%",
                height: "auto",
                borderRadius: 8,
                objectFit: "contain",
              }}
            />
          </Grid>
        </Grid>
      )}
    </Grid>
  );
};

export default IssueDetails;
